module.exports = __webpack_public_path__ + "static/media/landing_main_banner.83808de7.png";